import { DEV_MOCK_INITDATA, DEV_MOCK_USER_SEED } from '@yadviga/shared'
import type { HapticType, InvoicePayResult, PlatformAdapter, PlatformInitResult } from './adapter'

/**
 * Browser dev adapter — used when neither Telegram WebApp nor MAX bridge is present.
 * Returns the well-known DEV_MOCK_INITDATA constant; the API accepts it only when
 * DEV_MOCK_AUTH_ENABLED=true and resolves it to a fixed dev user.
 *
 * Reports `platform: 'telegram'` so end-to-end auth flows look identical to TG dev runs.
 */
export class MockPlatformAdapter implements PlatformAdapter {
  readonly platform = 'telegram' as const

  async init(): Promise<PlatformInitResult> {
    return {
      initDataRaw: DEV_MOCK_INITDATA,
      user: {
        id: DEV_MOCK_USER_SEED.platformUserId,
        firstName: DEV_MOCK_USER_SEED.name,
        languageCode: DEV_MOCK_USER_SEED.language,
      },
      theme: { colorScheme: 'light' },
    }
  }

  getLanguageHint(): string {
    return navigator.language || 'ru'
  }

  async share(payload: { url: string; text: string }): Promise<void> {
    if (navigator.share) {
      await navigator.share(payload)
    } else {
      await navigator.clipboard.writeText(`${payload.text}\n${payload.url}`)
      alert('Ссылка скопирована')
    }
  }

  async openLink(url: string): Promise<void> {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  async openInvoice(url: string): Promise<InvoicePayResult> {
    window.open(url, '_blank', 'noopener,noreferrer')
    return 'pending'
  }

  hapticFeedback(_type: HapticType): void {
    // no-op in browser
  }

  async showAlert(text: string): Promise<void> {
    alert(text)
  }

  closeApp(): void {
    // no-op in browser
  }

  getStartParam(): string | null {
    const params = new URLSearchParams(window.location.search)
    return params.get('startapp') ?? params.get('start_param')
  }
}
